
import AuthPage from "../../components/layout/authPage"
import { Col, Row, TabButtons, TabButtonsItem, Title, VImage } from "../../style/base.style"
import { doctorBanner, facebookIcon, googleIcon, loginBanner } from "../../constants/images"
import { useEffect, useState } from "react"
import { useDeviceType } from "../../contexts/DeviceContext"
import { RegistrationComponent } from "../../components/authentication/registration"
import { useSearchParams } from "react-router-dom";




export const LoginPage = () => {

  useEffect(() => {
    document.body.classList.add("contact-page");

    return () => document.body.classList.remove("contact-page");
  }, []);


const {isMobile} = useDeviceType()
    return (
      <AuthPage>
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <Col>
                {/* Login Tab Content */}
                <div className="contact-content">
                  <div className="row align-items-center justify-content-center">
                    {
                      !isMobile && 
                      <Col $width="40%">
                    
                      <VImage
                        src={doctorBanner}
                        className="img-fluid"
                        alt="Doccure Login"
                        
                      />
                      </Col>
                    }
                    
                    <RegistrationComponent currentForm="login"/>
                  </div>
                </div>
                {/* /Login Tab Content */}
              </Col>
            </div>
          </div>
        </div>
      </AuthPage>
        
    )

}